import React, { PropTypes, Component } from 'react';

export const RightNavButton = props => (
  <button {...props}>
    <i className="fa fa-angle-right" />
  </button>
);
export const LeftNavButton = props => (
  <button {...props}>
    <i className="fa fa-angle-left" />
  </button>
);



// WEBPACK FOOTER //
// ./common/components/carousel_controls.jsx